import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import IdolPlanner from './components/Idols/IdolPlanner'; 
import ShareStateService from './services/ShareStateService';
import TopBar from './components/UI/TopBar';

const App: React.FC = () => {
  const [isStateLoaded, setIsStateLoaded] = useState(false);

  useEffect(() => {
    // Check for shared state in URL
    const urlParams = new URLSearchParams(window.location.search);
    const shareParam = urlParams.get('s');
    
    if (shareParam) {
      // Load shared state from URL
      const stateLoaded = ShareStateService.loadSharedState();
      setIsStateLoaded(stateLoaded);
      
      // Clean URL by removing the share parameter
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    } else {
      // No share parameters to process
      setIsStateLoaded(true);
    }
  }, []);

  // Wait for state to be loaded before rendering routes
  if (!isStateLoaded) {
    return <div className="loading">Loading shared configuration...</div>;
  }

  return (
    <Router>
      <TopBar activeTool="idolplanner" />
      <Routes>
        <Route path="/" element={<IdolPlanner key={Date.now()} />} />
        {/* Specific route for PoE OAuth callback */}
        <Route 
          path="/auth/callback" 
          element={<IdolPlanner key={Date.now()} initialOpenStashExplorer={true} />} 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;